import MetaTags from '../components/common/MetaTags'

export default function TermsPage() {
  return (
    <>
      <MetaTags
        title="Terms of Service | profile.work"
        description="Read the terms and conditions for using profile.work."
      />
      <div className="py-16 sm:py-24">
        <div className="mx-auto max-w-3xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
              Terms of Service
            </h1>
            <p className="mt-6 text-sm text-gray-500">Last updated: January 2025</p>

            <div className="mt-12 space-y-10 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-900">1. Acceptance of Terms</h2>
                <p className="mt-4 leading-7">
                  By accessing or using profile.work, you agree to be bound by these Terms of
                  Service. If you do not agree to these terms, please do not use our service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">2. Description of Service</h2>
                <p className="mt-4 leading-7">
                  profile.work provides a platform for creating and hosting professional online
                  profiles. We offer tools to build, customize, and share your professional presence
                  on the web.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">3. User Accounts</h2>
                <p className="mt-4 leading-7">
                  You are responsible for maintaining the confidentiality of your account
                  credentials and for all activities that occur under your account. You must provide
                  accurate information when creating your account.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">4. User Content</h2>
                <p className="mt-4 leading-7">
                  You retain ownership of the content you create on profile.work. By using our
                  service, you grant us a license to display your public profile content. You are
                  responsible for ensuring your content does not violate any laws or third-party
                  rights.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">5. Prohibited Conduct</h2>
                <p className="mt-4 leading-7">You agree not to:</p>
                <ul className="mt-4 list-disc pl-6 space-y-2">
                  <li>Use the service for any illegal purpose</li>
                  <li>Impersonate another person or entity</li>
                  <li>Upload false or misleading information</li>
                  <li>Attempt to gain unauthorized access to our systems</li>
                  <li>Use the service to spam or harass others</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">6. Intellectual Property</h2>
                <p className="mt-4 leading-7">
                  The profile.work service, including its design, features, and content (excluding
                  user content), is protected by copyright and other intellectual property laws. You
                  may not copy, modify, or distribute our proprietary content without permission.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">7. Termination</h2>
                <p className="mt-4 leading-7">
                  We may suspend or terminate your account if you violate these terms. You may also
                  delete your account at any time. Upon termination, your profile will no longer be
                  publicly accessible.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">8. Disclaimer of Warranties</h2>
                <p className="mt-4 leading-7">
                  The service is provided "as is" without warranties of any kind. We do not
                  guarantee that the service will be uninterrupted, secure, or error-free.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">9. Limitation of Liability</h2>
                <p className="mt-4 leading-7">
                  To the maximum extent permitted by law, profile.work shall not be liable for any
                  indirect, incidental, or consequential damages arising from your use of the
                  service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">10. Changes to Terms</h2>
                <p className="mt-4 leading-7">
                  We may modify these terms at any time. Continued use of the service after changes
                  constitutes acceptance of the new terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900">11. Contact</h2>
                <p className="mt-4 leading-7">
                  For questions about these terms, contact us at{' '}
                  <a
                    href="mailto:legal@profile.work"
                    className="text-indigo-600 hover:text-indigo-500"
                  >
                    legal@profile.work
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
